import angular from 'angular';
import { MeurhInclusaodependenteService } from './inclusaodependente.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhInclusaodependenteListRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
    const resolve = {
        'entity': [
            'MeurhInclusaodependenteService',
            'ListagemService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhInclusaodependenteService,
                listagemService: ListagemService,
                $rootScope: angular.IRootScopeService & {
                    session: any,
                    liberadoTela: (arg: string) => boolean
                },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('meurh_inclusaodependente'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                        const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                        const mesmoEstabelecimento = data.estabelecimento.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                        const deveRedirecionar = (
                            (visibilidadeLiberada && !empresaNoGrupo) ||
                            (!visibilidadeLiberada && !mesmoEstabelecimento)
                        );

                        if (deveRedirecionar) {
                            return $q(() => $state.go('meurh_inclusaodependente'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => {
                                if ($state.href('meurh_inclusaodependente_not_found', $stateParams)) {
                                    $state.go('meurh_inclusaodependente_not_found', $stateParams);
                                } else {
                                    $state.go('not_found', $stateParams);
                                }
                            });
                        }

                        return $q.reject(error);
                    });
            }
        ]
    };

    $stateProvider
        .state('meurh_inclusaodependente', {
            url: '/inclusaodependente?q',
            template: require('html-loader!./index/inclusaodependente.index.html'),
            controller: 'MeurhInclusaodependenteIndexController',
            controllerAs: 'mrh_inclsdpdt_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('meurh_inclusaodependente_new', {
            url: '/inclusaodependente/new',
            template: require('html-loader!./new/inclusaodependente.new.html'),
            controller: 'MeurhInclusaodependenteNewController',
            controllerAs: 'mrh_inclsdpdt_frm_nw_cntrllr'
        })
        .state('meurh_inclusaodependente_show', {
            parent: 'meurh_inclusaodependente',
            url: 'show/:solicitacao?path',
            resolve,
            template: require('html-loader!./show/inclusaodependente.show.html'),
            controller: 'MeurhInclusaodependenteShowController',
            controllerAs: 'mrh_inclsdpdt_frm_shw_cntrllr'
        });
    }
];
